import React from 'react';
import styled from '@emotion/styled';
import { SPACING_2B, SPACING_6 } from '@styles/constants/spacings';
import { mediaQuery } from '@styles/index';

interface FlexColumnProps {
  className?: string;
  columnWidth?: number;
  children: React.ReactNode;
}

type FlexColumnType = {
  $columnWidth?: number;
};

const StyledFlexColumn = styled.div<FlexColumnType>`
  padding: ${SPACING_2B};
  flex: 0 0 50%;
  max-width: 50%;
  ${mediaQuery.uptoTablet} {
    flex: ${({ $columnWidth }) => `0 0 ${$columnWidth || '100'}%`};
    max-width: ${({ $columnWidth }) => $columnWidth || '100'}%;
    padding: ${SPACING_6};
  }
`;

const FlexColumn: React.FC<FlexColumnProps> = ({
  className,
  columnWidth,
  children
}) => {
  return (
    <StyledFlexColumn $columnWidth={columnWidth} className={className}>
      {children}
    </StyledFlexColumn>
  );
};

FlexColumn.displayName = 'FlexColumn';

FlexColumn.defaultProps = {
  className: '',
  columnWidth: 0
};

export default FlexColumn;
